import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

type Props = {
	onRemoveDecisionMaker: () => void;
	setEditing: () => void;
};

type UseDecisionMakerCardReturn = ModelHookResult<
	undefined,
	{
		onRemoveDM: () => void;
		onEditDM: () => void;
	}
>;

export function useDecisionMakerCard({ onRemoveDecisionMaker, setEditing }: Props): UseDecisionMakerCardReturn {
	const track = useTracking();

	const onRemoveDM = useCallback(() => {
		onRemoveDecisionMaker();
	}, [onRemoveDecisionMaker]);

	const onEditDM = useCallback(() => {
		setEditing();
		void track('petition_edit_decision_maker_edit_click');
	}, [setEditing, track]);

	return {
		actions: {
			onRemoveDM,
			onEditDM,
		},
	};
}
